import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserProfilePicture, getUsersTmpProfilePicture } from '../user-selectors';
import { updateProfilePicture, cropProfilePicture } from '../user-actions';
import { showErrorModal } from '../../global-message/global-message-actions';
import AvatarEditableWrapper from '../../components/avatar/AvatarEditableWrapper';
import Avatar from '../../components/avatar/Avatar';

const EditProfileImage = () => {
    const [isFetchingImage, setIsFetchingImage] = useState(false);
    const [isCropping, setIsCropping] = useState(false);
    const dispatch = useDispatch();
    const tmpImageUrl = useSelector((state) => getUsersTmpProfilePicture(state));
    const imageUrl = useSelector((state) => getUserProfilePicture(state));

    const updateImage = async (file) => {
        setIsFetchingImage(true);
        try {
            await dispatch(updateProfilePicture(file));
        } finally {
            setIsFetchingImage(false);
        }
    };
    const cropHandler = async (crop) => {
        setIsCropping(true);
        await dispatch(cropProfilePicture(crop));
        setIsCropping(false);
    };
    const onDropRejected = () => dispatch(showErrorModal('Bildefilen du prøver å laste opp støttes ikke'));
    const onError = () => dispatch(showErrorModal('Noe gikk galt med opplastning av bilde'));

    return (
        <AvatarEditableWrapper
            onDropRejected={onDropRejected}
            onError={onError}
            updateImage={updateImage}
            tmpImageUrl={tmpImageUrl}
            cropHandler={cropHandler}
            isCroppingImage={isCropping}
            isUploadingImage={isFetchingImage}
        >
            <Avatar imageSrc={imageUrl} size="xl" />
        </AvatarEditableWrapper>
    );
};

export default EditProfileImage;
